require('./brokerNewsColumn.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;

const StorySummary = require('./brokerStorySummary');
//@commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKLink } = require('commonsComponents/OKLink');
const { DATE_FORMAT_ES, BROKER_NEWS_MAX_SHOW_LIMIT } = require('constants/index');
const DateHelper = require('utilities/dateHelper');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @helpers
const { taggingEventHandled } = require('utilities/taggingEventHandled');

class NewsColumn extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            newsIndex : BROKER_NEWS_MAX_SHOW_LIMIT
        }
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        const { requestNews, maxNews } = this.props;
        requestNews(maxNews);
    }

    handleClick () {
        const { newsIndex } = this.state;
        const { maxNews } = this.props;
        if ( newsIndex < maxNews ) {
            this.setState(prevState => (
                {newsIndex:  prevState.newsIndex + BROKER_NEWS_MAX_SHOW_LIMIT }
            ))
        }
    }

    buildArticles() {
        const {
            immBrokerNews,
            width,
            hasTime,
            newsSection,
            pageName
        } = this.props;

        const { newsIndex } = this.state;

        const newsData = immBrokerNews.get('byOrder').slice(0, newsIndex).map(function(newsId, index){
            const immNews = immBrokerNews.getIn(['byId', newsId]);
            const articleTime = (hasTime) ? `- ${immNews.get('date').split(' ').pop().slice(0,-3)}` : '';
            const parsedDate = `${DateHelper.buildFormattedDate(immNews.get('date'), DATE_FORMAT_ES)} ${articleTime}`;
            const link = `/myprofile/broker/news/${immNews.get('id')}`;
            const summary = immNews.get('entradilla').length ? immNews.get('entradilla') : immNews.get('cuerpo');
            const classWidth = __CONTACT_CENTER__ ? `${width} broker-news-column-content__article` : width;

            return (
                <article key={index} className={classWidth}>
                    <StorySummary
                        myDate={parsedDate}
                        title={immNews.get('titulo')}
                        summary={summary}
                        readMore={true}
                        myPath={link}
                        newsSection={newsSection}
                        leftIcon={true}
                        newIndex={index}
                        pageName={pageName}
                    />
                </article>
            );
        });

        return newsData;
    }

    render() {
        const {
            immBrokerNews,
            newsSection,
            pageName
        } = this.props;

        const { newsIndex } = this.state;

        const title = formatText('broker-newsColumnTitle');
        const brokerNews = immBrokerNews.get('byOrder');
        let loadMoreAnchor;
        if ( newsIndex < brokerNews.size ) {
        loadMoreAnchor = (
            <div className="pull-right">
                <OKLink
                    modifier="emphasize"
                    className="broker-news-column__link'"
                    onClick={this.handleClick}
                >
                    <FormattedText value="broker-newsColumnLoadMore" />
                </OKLink>
            </div>
        );
        }

        const seeAllAnchor = (
            <div className="pull-right">
                <OKLink
                    modifier="widget"
                    className="broker-news-column__link'"
                    to="/myprofile/broker/news"
                    onClick={() => taggingEventHandled(pageName, 'newsCardSeeAll')}
                >
                    <FormattedText value="broker-newsColumnSeeAll" />
                </OKLink>
            </div>
        );

        const rightIcon = (
            <OKIconIllustrative icon="news" product="wealth" />
        );

        if ( immBrokerNews.get('isFetching') ) {
            return (<LoadingSection />);
        }

        if ( immBrokerNews.get('error') ) {
            return (<EmptyState primaryText={formatText('broker-emptyNews')} iconType="nointernet-wealth"/>);
        }

        const stories = this.buildArticles();
        let storiesColumn;

        if (newsSection) {
            storiesColumn = (
                <div className="row">
                    {stories}
                    {newsSection ? loadMoreAnchor : null}
                </div>
            );
        }
        else {
            storiesColumn = (
                <ContentBox
                    id="brokerNewsColumn"
                    title={!newsSection ? title : null}
                    customClassName="broker-news-column"
                    modifier="complementary"
                    product="wealth"
                    rightContent={rightIcon}
                    footerContent={!newsSection ? seeAllAnchor : null}>
                    <div className="row broker-news-column-content">
                        {stories}
                        {newsSection ? seeAllAnchor : null}
                    </div>
                </ContentBox>
            );
        }

        if (stories.size === 0) {
            storiesColumn = (
                <EmptyState
                    primaryText={formatText('broker-emptyNews')}
                    iconType="noitems-wealth" />
            );
        }

        return storiesColumn;
    }
}

NewsColumn.defaultProps = {
    hasTime: false
}

NewsColumn.propTypes = {
    immBrokerNews: PropTypes.object.isRequired,
    requestNews: PropTypes.func.isRequired,
    width: PropTypes.string.isRequired,
    maxNews: PropTypes.number.isRequired,
    newsIndex: PropTypes.number.isRequired,
    newsSection: PropTypes.bool.isRequired,
    handleClick: PropTypes.func,
    hasTime: PropTypes.bool,
    pageName: PropTypes.string
}

module.exports = NewsColumn;